module.exports = __webpack_public_path__ + "static/media/process_gears_vnt.56e455ff.png";